<template>
  <div>
    <div class="form-element">
      <label class="form-label">账号</label>
      <input v-if="user" type="text" class="input" name="username" placeholder="" v-model="user.name"
             disabled="disabled">
    </div>
    <div class="form-element b10">
      <label class="form-label" p-id="">密码</label>
      <input type="text" class="input" disabled="disabled" value="******">
    </div>
    <div class="form-element d-l">
      <input :type="isShowPwd ? 'text' : 'password'" class="input" placeholder="输入新密码" value="" v-model="newPwd"
             autocomplete="new-password">
      <a href="javascript:void(0)">
        <img v-if="isShowPwd" src="../assets/imgs/eyes2.svg" style="width: 20px;" @click="isShowPwd = !isShowPwd">
        <img v-else src="../assets/imgs/eyes1.svg" style="width: 20px;" @click="isShowPwd = !isShowPwd">
      </a>
    </div>
    <div class="form-element">
      <label class="form-label">手机</label>
      <input type="text" class="input" name="phone" placeholder="填写手机号码" value="" v-model="phone">
    </div>
    <div class="form-element d-l" v-show="false">
      <input type="checkbox" id="phone-tz" v-model="spPhoneTongzhi">
      <label class="i-label" for="phone-tz">审批通知发送至我的手机号</label>
    </div>
    <div class="form-element b10">
      <label class="form-label">联系邮箱</label>
      <input type="text" class="input" name="email" placeholder="填写邮箱账号" value="" v-model="email">
    </div>
    <div class="form-element d-l" v-show="false">
      <input type="checkbox" id="mail-tz" v-model="spEmailTongzhi">
      <label class="i-label" for="mail-tz">审批通知发送至我的邮箱</label>
    </div>
    <div class="form-element btns" :class="{'active': isUpdate}">
      <span class="btn active" @click="save">保存</span>
      <span class="btn btn-normal" @click="cancel">取消</span>
    </div>
  </div>
</template>

<script>
import '../assets/styles/setting-m.css';
import '../assets/styles/setting.css';
import util from "../util";

function setIsUpdate() {
  console.log('set is update')
  this.isUpdate = true;
}

export default {
  data() {
    return {
      isShowPwd: false,
      isUpdate: false,
      newPwd: '',
      email: '',
      phone: '',
      spEmailTongzhi: false,
      spPhoneTongzhi: false,
      curUser: null
    }
  },
  inject: ['componentRoot'],
  methods: {
    save() {
      let data = util.clone(this.user)
      let isPwdUpdate = false;
      if (this.newPwd) {
        data.pwd = this.newPwd
        isPwdUpdate = true
      }
      data.email = this.email
      data.phone = this.phone
      data.spEmailTongzhi = this.spEmailTongzhi
      data.spPhoneTongzhi = this.spPhoneTongzhi

      var self = this;
      this.$post('/user/update', data, res => {
        self.newPwd = '';
        if (isPwdUpdate)
          self.componentRoot.$refs.tHead.logout()
        else {
          self.componentRoot.$refs.tLogin.username = res.name
          self.componentRoot.$refs.tLogin.pwd = res.pwd
          self.componentRoot.$refs.tLogin.login()
        }
      })
    },
    cancel() {
      this.setField(this.user)
    },
    setField(user) {
      var self = this;

      function set(field, defaultValue = '') {
        let val = user ? user[field] : defaultValue
        self[field] = val
      }

      set('email')
      set('phone')
      set('spEmailTongzhi', false)
      set('spPhoneTongzhi', false)
      this.$nextTick(() => {
        console.log('set is update false')
        this.isUpdate = false
      })
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    'newPwd': setIsUpdate,
    'email': setIsUpdate,
    'phone': setIsUpdate,
    'spEmailTongzhi': setIsUpdate,
    'spPhoneTongzhi': setIsUpdate,
    user(newUser) {
      this.setField(newUser)
    }
  },
  mounted() {
    this.setField(this.user)
    window.$settingAccount = this
  }
}
</script>
